import { render, staticRenderFns } from "./AppInputFileupload.vue?vue&type=template&id=04561b13&scoped=true&"
import script from "./AppInputFileupload.vue?vue&type=script&lang=js&"
export * from "./AppInputFileupload.vue?vue&type=script&lang=js&"
import style0 from "./AppInputFileupload.vue?vue&type=style&index=0&id=04561b13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04561b13",
  null
  
)

export default component.exports